import { NavigationExtras } from '@angular/router';
import { createAction, props, union } from '@ngrx/store';

export const Go = createAction(
  '[Router] GO',
  // eslint-disable-next-line @typescript-eslint/ban-types
  props<{ path: any[]; query?: object; extras?: NavigationExtras }>(),
);
// export const Navigate = createAction('[Router] NAVIGATE', props<{  }>());
export const Navigate = createAction('[Router] NAVIGATE');
export const Back = createAction('[Router] BACK');
export const Forward = createAction('[Router] FORWARD');

export const RouterActions = union({
  Go,
  Back,
  Forward,
});
